import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import Constants from "../../constants";
import { getShowPrice, getSummaryData, getTotalPrice } from "../../store/sagas/selectors";
import { usePriceFormatter } from "../../utilities/priceFormatter";
import { useText } from "../../utilities/textUtil";

const ContinueButton = styled.div`
    background: var(--primary-color);
    color: white;
    position: absolute;
    right: 18px;
    height: 42px;
    border-radius: 21px;
    top: calc(${Constants.mobileImageHeightVw}vw + 20px);
    box-sizing: border-box;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    white-space: nowrap;
    min-width: min(170px, 45%);
    cursor: pointer;
`;

const ContinueText = styled.div`
    flex-grow: 1;
    margin: 0 8px;
    text-align: left;
`;

export const MobileContinueButton = ({ onContinue }: { onContinue: () => void }) => {
    const showPrice = useSelector(getShowPrice);
    const summaryData = useSelector(getSummaryData);
    const totalPrice = useSelector(getTotalPrice);
    const t = useText();
    const priceFormatter = usePriceFormatter(false);
    const totalPriceText = priceFormatter.formatPrice(totalPrice);
    return (
        <ContinueButton onClick={onContinue}>
            <span className="material-icons">arrow_forward</span>
            <ContinueText>{t("summaryContinue")}</ContinueText>
            {showPrice && summaryData?.totalPrice ? <span>{totalPriceText}</span> : null}
        </ContinueButton>
    );
};
